import React from "react";
import { Spinner, Alert } from "reactstrap";
import { Breadcrumb } from "../../../components/Common";
import { useReceivables } from "./hooks/useReceivables";
import ReceivableTable from "./components/ReceivableTable";

/**
 * ReceivablesPage
 * Tela de Contas a Receber — lista financialRecords do tipo INCOME.
 * Por padrão carrega apenas o DIA ATUAL (econômico).
 */
const ReceivablesPage = () => {
    document.title = "Recebíveis | NeoApp - Sistema de Gestão";

    const {
        records,
        summary,
        loading,
        error,
        hasMore,
        processing,
        statusFilter,
        search,
        startDate,
        endDate,
        setStatusFilter,
        setSearch,
        setStartDate,
        setEndDate,
        actions,
    } = useReceivables();

    return (
        <React.Fragment>
            {/* ═══ HEADER ═══ */}
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Contas a Receber" />
            </div>
            
            <div className="border-top mb-3"></div>

            {/* ═══ LOADING INICIAL ═══ */}
            {loading && !records.length && (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="text-muted mt-2">Carregando recebíveis...</p>
                </div>
            )}

            {/* ═══ ERRO ═══ */}
            {error && !loading && (
                <Alert color="danger" className="d-flex align-items-center">
                    <i className="mdi mdi-alert-circle-outline me-2 fs-5" />
                    <div>
                        <strong>Erro ao carregar dados:</strong> {error?.message || String(error)}
                        <button className="btn btn-link btn-sm p-0 ms-2" onClick={actions.refresh}>
                            Tentar novamente
                        </button>
                    </div>
                </Alert>
            )}

            {/* ═══ CONTEÚDO ═══ */}
            {(!loading || records.length > 0) && !error && (
                <ReceivableTable
                    records={records}
                    summary={summary}
                    processing={processing}
                    search={search}
                    statusFilter={statusFilter}
                    startDate={startDate}
                    endDate={endDate}
                    onSearchChange={setSearch}
                    onStatusChange={setStatusFilter}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                    onMarkAsPaid={actions.markAsPaid}
                    onCancel={actions.cancelRecord}
                    onLoadMore={actions.loadMore}
                    hasMore={hasMore}
                    loading={loading}
                />
            )}
        </React.Fragment>
    );
};

export default ReceivablesPage;
